import { faGrinWink } from '@fortawesome/free-regular-svg-icons'
import {faPercent, faStore } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import BurgerMenuTitle from '../../Component/BurgerMenuTitle/BurgerMenuTitle'
import NumberOfOrder from '../NumberOfOrder/NumberOfOrder'
import Style from './More.module.css'

const More = (props) => {
    return ( 
        <div className={Style.pageHolder}>
            <BurgerMenuTitle title={props.title}/>
            <div className={Style.center}>
                <h2 className={Style.headerText}><FontAwesomeIcon className={Style.emoji} icon={faGrinWink}/>{props.headerText}</h2>
                <ul className={Style.productsHolder}>
                    {props.data.map((item,index)=>
                        <li key={index} className={Style.productItem}>
                            
                            {/* <Link to={{pathname:`/product/${item.id}/${path[3]===undefined?'':path[3]}`,state:item.id}} className={Style.ATag}> */}
                            <div className={Style.picHolder}>
                                <img src={`//cdn.barest.ir/product/m/${item.id}.jpg`} alt="محصولات"/>
                                <div className={Style.percentHolder}>
                                    <h3 className={Style.percent}>تخفیف<FontAwesomeIcon className={Style.percenticon} icon={faPercent}/></h3>
                                    
                                </div>
                            </div>
                            {/* </Link> */}
                            <div className={Style.textHolder}>
                                <h2 className={Style.productName}>{item.name}</h2>
                                {props.supery? null :<h3 className={Style.supName}><FontAwesomeIcon className={Style.shopIcon} icon={faStore}/>{item.supplier}</h3>}
                                <div className={Style.priceHolder}>
                                    <h3 className={Style.noPrice}><span>{item.price}</span>تومان</h3>
                                    <h3 className={Style.offprice}><span>{item.off_price}</span>تومان</h3>  
                                </div>
                            </div>
                            <div className={Style.counter}>
                                <NumberOfOrder dataUpdate={props.category} supId={props.supery?props.supId:item.supplier_id} data={item}/>
                            </div> 
                        </li>
                    )}
                </ul>
            </div>
        </div>
    )
}

export default More
